<template>
    <div
        class="modal"
        v-if="showNextCardMethodModal"
        aria-labelledby="my-next-card-methodology-modal"
        role="dialog"
        aria-modal="true"
    >
        <div class="modal-overlay" aria-hidden="true"></div>
        <div
            class="
                inner
                rounded-lg
                bg-white
                shadow
                border border-gray-200
                overflow-hidden
                w-full
                max-w-3xl
                p-4
            "
             style="-webkit-transform:translate3d(0,0,0);"
        >
            <div class="absolute top-0 right-0 pt-4 pr-6 block">
                <button
                    type="button"
                    class="
                        rounded-md
                        bg-white
                        text-gray-400
                        hover:text-gray-500
                        focus:outline-none
                        focus:ring-2 focus:ring-orange-400 focus:ring-offset-2
                    "
                    @click.prevent="closeModal()"
                >
                    <span class="sr-only">Close</span>
                    <i class="fal fa-times fa-2x"></i>
                </button>
            </div>

            <div class="modal-body items-start prose">
                <img
                    src="/images/mynextcard.png"
                    class="mx-auto w-1/3 mb-1"
                    alt="My Next Card"
                />
                <h3
                    class="
                        text-xl
                        md:text-2xl
                        text-gray-800
                        font-bold
                        mt-2
                        mb-5
                        text-center
                    "
                >
                    How does My Next Card Work?
                </h3>
                <p>
                    My Next Card looks at your current credit cards, points
                    balances, credit score, and other factors to recommend the
                    best credit cards for you and you alone.
                </p>

                <p>
                    These recommendations are driven by the above factors as
                    well as our own analysis of the best credit card offers on
                    the market. We rank these offers by looking at a card’s
                    signup bonus, spending rewards, benefits, and annual fee to
                    determine which cards will offer more value to the average
                    person.
                </p>

                <p>
                    Of course everyone’s circumstances are a little bit
                    different, so we encourage you to compare multiple credit
                    card offers to be sure that you are making the right choice.
                </p>
                <!-- -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useAppStore } from "@/store/app";

export default {
    props: {},
    data: () => ({}),
    computed: {
        ...mapState(useAppStore, ["showNextCardMethodModal"]),
    },
    methods: {
        ...mapActions(useAppStore, ["setShowNextCardMethodModal"]),
        closeModal() {
            this.setShowNextCardMethodModal(false);
        },
    },
    mounted() {},
};
</script>
